import './i18n';
import { useRoutes, useNavigate } from 'react-router-dom';
import { appRoutes } from './router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'moment/dist/locale/de';
import moment from 'moment';
moment.locale('de');

// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { ReportsProvider } from './features/reports/context/ReportsContext';
import { useEffect } from 'react';
import { registerNavigator } from './utils/errorHandling';

// Create a client with default options to reduce unnecessary requests
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnMount: true, // Refetch on mount for fresh data
      staleTime: 0, // Always consider data stale, always refetch
      gcTime: 300000, // Keep in cache for 5 minutes
      retry: 1 // Only retry failed requests once
    }
  }
});

// Named function component for better HMR compatibility
function App() {
  const content = useRoutes(appRoutes);
  const navigate = useNavigate();

  // Register navigator for programmatic navigation to error pages
  useEffect(() => {
    registerNavigator(navigate);
  }, [navigate]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
        <AuthProvider>
          <CssBaseline />
          <ErrorBoundary>{content}</ErrorBoundary>
        </AuthProvider>
        {/* </LocalizationProvider> */}
      </ThemeProvider>
    </QueryClientProvider>
  );
}

// Named export for better HMR compatibility
export default App;
